// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__NLhag","logotype":"Header_logotype__MNmyS","inverted":"Header_inverted__Ssehk"};